import React from "react";
import Button from "../../Components/Utils/Button/Button";
import styles from "./Library.module.css";

type SelectionBarProps = {
  count: number;
  canDelete: boolean;
  onMove: () => void;
  onDelete: () => void;
  onClear: () => void;
};

const SelectionBar = ({ count, canDelete, onMove, onDelete, onClear }: SelectionBarProps) => {
  if (count === 0) return null;
  return (
    <div className={styles.selectionBar} role="status">
      <span>{count === 1 ? "1 selected" : `${count} selected`}</span>
      {canDelete && (
        <Button colour="#fff" textColour="#24394F" size="Small" clickHandler={onMove}>
          Move
        </Button>
      )}
      {canDelete && (
        <Button colour="#b42318" textColour="#fff" size="Small" clickHandler={onDelete}>
          Delete
        </Button>
      )}
      <Button colour="#fff" textColour="#24394F" size="Small" clickHandler={onClear}>
        Clear
      </Button>
    </div>
  );
};

export default SelectionBar;
